export default {
  welcomeDialog: {
    logoAlt: 'France Rugby logo',
    welcome: {
      introduction: {
        firstParagraph: {
          welcome: 'Welcome to the',
          description: ' app, your ally for training and maximizing your potential, designed for all athletes, beginners and experts alike!'
        },
        secondParagraph: {
          noMoralizingSpeech: 'Here, there’s no moralizing speech, just',
          practicalAdvices: 'practical and inspiring advice, in a dynamic and safe journey',
          capableOfBoosting: ', designed to boost your',
          performance: 'performance',
          andYour: 'and your',
          recovery: 'recovery',
          whileTakingCareOf: ', while taking care of your',
          mentalHealth: 'mental health',
          andYour2: 'and your',
          wellBeing: 'well-being.'
        },
        thirdParagraph: {
          theIdea: 'The idea?',
          toAssistYou: 'To guide you step by step so that every day counts in your progress.'
        }
      },
      description: {
        withThisApplication: 'With this app,',
        youHaveEverything: 'you have everything you need to track your progress, understand your body and mind, and give the best of yourself:',
        selfEvaluationForm: 'Simple, quick, and effective questionnaires to self-assess your daily fitness level.',
        physicalAndCognitiveExercises: 'Scientifically validated physical and cognitive exercises to strengthen your body and brain, designed to boost your recovery and improve your performance.',
        balanceTests: 'Balance tests with video analysis to discover your strengths and the areas to improve, guide you precisely, and train your stability and reflexes.',
        breathingExercises: 'Breathing exercises specially designed to calm your mind, regulate your stress, and boost your well-being.',
        tipsAndRoutines: 'Tips and routines to improve the quality of your sleep and optimize your recovery.',
        nutritionRecommendation: 'Nutritional recommendations to provide all the nutrients needed for your activity.'
      },
      recap: {
        whatYouWillLike: 'What you’ll love',
        aCustomSupport: 'Personalized support, validated by experts, that guides you step by step for a better experience, helps you progress at your own pace and without pressure, and lets you track your progress day after day, so that every session is truly beneficial to you.',
        keyToSuccess: 'The key to success? Consistency.',
        beRegular: 'By committing every day, at your own pace, you take charge of your health, promote effective recovery, optimize your performance, and cultivate strong mental health. Doing these exercises regularly is the secret to becoming stronger, faster, and more focused.',
        readyToSurpassYourself: 'So, ready to push your limits?'
      },
      conclusion: {
        withTheApplication: 'With the {appName} app',
        completeAndCustomProgram: ', you benefit from a complete and personalized program.',
        changeYourEffortsIntoSuccess: 'Turn your efforts into success, so you can be confident and ready to take on every challenge!'
      }
    },
    startButton: 'Start'
  },
  concussionHistory: {
    logoAlt: 'France Rugby logo',
    title: 'Concussion History',
    instructions: {
      description1: 'This questionnaire allows us to collect information about your concussion history.',
      description2: 'This information will help personalize your medical follow-up.',
      startButton: 'Start'
    },
    form: {
      previousConcussions: {
        title: 'Previous concussions',
        toggle: 'I have already suffered one or more concussions'
      },
      concussionDetails: {
        title: 'Concussion',
        date: 'Approximate date (month/year)',
        circumstances: 'Circumstances (match, training, other)',
        symptoms: 'Main symptoms experienced',
        duration: 'Duration of symptoms (days)',
        medicalConsultation: 'I consulted a doctor for this concussion',
        treatment: 'Treatment or medical follow-up received'
      },
      addConcussion: 'Add a concussion',
      additionalInfo: {
        title: 'Additional information',
        label: 'Other relevant information about your history'
      },
      submitButton: 'Submit'
    },
    confirmation: {
      title: 'Questionnaire submitted',
      thankYou: 'Thank you for completing the concussion history questionnaire.',
      recordedHistory: 'Recorded history: {count} concussion(s)',
      medicalTeamInfo: 'This information will be used by the medical team to personalize your follow-up.',
      backButton: 'Back'
    }
  },
  concussionSymptoms: {
    logoAlt: 'France Rugby logo',
    title: 'Symptom Self-Assessment',
    instructions: {
      description1: 'This questionnaire is part of the official FFR protocol (inspired by SCAT5) and must be completed daily until your full recovery.',
      description2: 'For each symptom, please indicate:',
      presence: 'Its presence or absence',
      severity: 'Its severity level (on a scale from 0 to 6)',
      startButton: 'Start'
    },
    form: {
      severityLegend: 'Severity: 0 (none) to 6 (severe)',
      categories: {
        physical: 'Physical symptoms',
        cognitive: 'Cognitive symptoms',
        emotional: 'Emotional symptoms',
        sleep: 'Sleep-related symptoms'
      },
      severity: 'Severity',
      submitButton: 'Submit'
    },
    confirmation: {
      title: 'Questionnaire submitted',
      thankYou: 'Thank you for completing the symptom self-assessment questionnaire.',
      backButton: 'Back'
    }
  },
  progressiveReturnFollowUp: {
    logoAlt: 'France Rugby logo',
    title: 'Progressive Return to Play Program (PRTP)',
    instructions: {
      description1: 'This questionnaire is part of the official FFR protocol for progressive return to play after a concussion.',
      description2: 'You must complete this questionnaire after each return stage to validate the absence of symptoms before moving to the next stage.',
      startButton: 'Start'
    },
    form: {
      stageTitle: 'Stage {stage} Questionnaire',
      currentStage: {
        title: 'Current stage',
        selectLabel: 'Select your current stage'
      },
      plannedActivity: {
        title: 'Planned activity',
        label: 'Describe the activity performed during this stage'
      },
      activityCompletion: {
        title: 'Activity completion',
        toggle: 'I completed the planned activity'
      },
      symptomsAppearance: {
        title: 'Symptom appearance',
        toggle: 'Symptoms appeared during or after the activity',
        warning: 'Warning: The presence of symptoms requires returning to the previous stage. Consult your doctor.',
        specifySymptoms: 'Please specify the symptoms that appeared:'
      },
      severityLegend: 'Severity: 0 (none) to 6 (severe)',
      categories: {
        physical: 'Physical symptoms',
        cognitive: 'Cognitive symptoms',
        emotional: 'Emotional symptoms',
        sleep: 'Sleep-related symptoms'
      },
      comments: {
        title: 'Comments',
        label: 'Additional comments'
      },
      submitButton: 'Submit'
    },
    confirmation: {
      title: 'Questionnaire submitted',
      stageTitle: 'Progressive Return to Play Program - Stage {stage}',
      thankYou: 'Thank you for completing the follow-up questionnaire for stage {stage}.',
      symptomsWarning: 'Warning: Symptoms appeared. You must return to the previous stage and consult your doctor.',
      congratulations: 'Congratulations: You completed this stage without symptoms. You can move to the next stage after 24h.',
      activityNotCompleted: 'Activity not completed: Try to complete the activity before moving to the next stage.',
      nextStage: 'Next stage: {description}',
      backButton: 'Back'
    },
    stages: {
      options: {
        1: 'Stage 1: Complete rest',
        2: 'Stage 2: Light activity',
        3: 'Stage 3: Rugby-specific exercises',
        4: 'Stage 4: Non-contact training',
        5: 'Stage 5: Contact training',
        6: 'Stage 6: Return to play'
      },
      descriptions: {
        1: 'Complete physical and cognitive rest until symptoms disappear.',
        2: 'Light aerobic activities like walking or low-intensity stationary cycling.',
        3: 'Rugby-specific exercises without risk of head impact.',
        4: 'More complex training exercises without contact.',
        5: 'After medical clearance, return to normal training activities with contact.',
        6: 'Return to normal play after medical clearance.'
      },
      stage7: 'Stage 7: Return to play - After medical clearance.'
    }
  },
  symptoms: {
    // Physical symptoms
    headache: 'Headache',
    nausea: 'Nausea',
    vomiting: 'Vomiting',
    dizziness: 'Dizziness / Feeling of vertigo',
    visionProblems: 'Vision problems (blurred, double vision)',
    lightSensitivity: 'Light sensitivity',
    noiseSensitivity: 'Noise sensitivity',
    balanceProblems: 'Balance problems',
    fatigue: 'Physical fatigue',
    slowness: 'Feeling of slowness',
    // Cognitive symptoms
    mentalConfusion: 'Confusion / Disorientation',
    memoryProblems: 'Memory problems',
    concentrationDifficulties: 'Concentration difficulties',
    mentalSlowness: 'Feeling of "mental slowness"',
    // Emotional symptoms
    irritability: 'Irritability',
    sadness: 'Sadness or depressive mood',
    anxiety: 'Anxiety / Nervousness',
    moodSwings: 'Mood swings',
    // Sleep symptoms
    sleepProblems: 'Sleep onset problems',
    excessiveSleepiness: 'Excessive sleepiness',
    poorSleepQuality: 'Frequent awakenings / Poor sleep quality'
  },
  exercises: {
    sections: {
      videoExercises: 'My video exercises',
      exercises: 'My exercises',
      breathing: 'My breathing',
      questionnaires: 'My questionnaires'
    },
    tests: {
      dsst: {
        name: 'DSST Test',
        description: 'Processing speed and sustained attention',
        instructions: {
          title: 'Instructions for the DSST test',
          description1: 'This test measures your processing speed and sustained attention.',
          description2: 'You will see a series of digits, one at a time. For each digit, you must select the corresponding symbol according to the legend displayed at the top of the screen.',
          description3: 'Try to respond as quickly and accurately as possible.',
          description4: 'The test lasts {count} seconds.',
          startButton: 'Start Test'
        },
        running: {
          timeRemaining: 'Time remaining:',
          question: 'Question:'
        },
        results: {
          title: 'DSST Test Results',
          score: 'Score',
          accuracy: 'Accuracy',
          averageResponseTime: 'Average response time',
          correctAnswers: 'Correct answers',
          retryButton: 'Retry Test'
        }
      },
      srt: {
        name: 'SRT Test',
        description: 'Reaction time evaluation',
        instructions: {
          title: 'Instructions for the SRT test',
          description1: 'This test measures your simple reaction time.',
          description2: 'A visual stimulus (a shape) will appear on the screen. Click as quickly as possible as soon as you see the stimulus.',
          description3: 'Your reaction time will be measured in milliseconds.',
          description4: 'The test includes {count} trials.',
          startButton: 'Start Test'
        },
        running: {
          trial: 'Trial: {current} / {total}',
          remaining: 'Remaining: {count}',
          waiting: 'Wait for the stimulus to appear...',
          lastTime: 'Last time: {time}'
        },
        results: {
          title: 'SRT Test Results',
          score: 'Score (average of the 10 best)',
          avgReactionTime: 'Average reaction time',
          fastestTime: 'Fastest time',
          validTrials: 'Valid trials',
          retryButton: 'Retry Test'
        }
      },
      goNoGo: {
        name: 'Go/No-Go Test',
        description: 'Behavioral inhibition and sustained attention',
        instructions: {
          title: 'Instructions for the Go/No-Go test',
          description1: 'This test measures your behavioral inhibition capacity, sustained attention, and processing speed.',
          description2: 'Two types of stimuli will appear on the screen:',
          goStimulus: '"Go" Stimulus (green circle): Click as quickly as possible.',
          noGoStimulus: '"No-Go" Stimulus (red cross): Do NOT click, inhibit your response.',
          description3: 'Each stimulus will appear for a short duration. Try to be as fast and precise as possible.',
          startButton: 'Start Test'
        },
        running: {
          trial: 'Trial: {current} / {total}',
          remaining: 'Remaining: {count}',
          waiting: 'Wait for the stimulus to appear...',
          missedGo: 'Missed! (Go)',
          correctNoGo: 'Correct! (No-Go)',
          correctGo: 'Correct! (Go) - {time}',
          incorrectNoGo: 'Incorrect! (No-Go)'
        },
        results: {
          title: 'Go/No-Go Test Results',
          avgReactionTime: 'Average reaction time (Go)',
          inhibitionRate: 'Inhibition rate',
          commissionErrors: 'Commission errors (No-Go)',
          omissionErrors: 'Omission errors (Go)',
          retryButton: 'Retry Test'
        }
      },
      stroop: {
        name: 'Stroop Test',
        description: 'Cognitive inhibition and selective attention',
        instructions: {
          title: 'Instructions for the Stroop test',
          description1: 'This test measures your cognitive inhibition capacity and selective attention.',
          description2: 'You will see color words (e.g., "RED", "GREEN") displayed in different colors.',
          description3: 'Your task is to select the color in which the word is written, not what the word says.',
          description4: 'For example, if you see the word "RED" written in green color, you must select "GREEN".',
          description5: 'Try to respond as quickly and accurately as possible.',
          startButton: 'Start the test'
        },
        colorVision: {
          title: 'Color vision test',
          description: 'Please choose the color palette that suits you best:',
          palettes: {
            standard: {
              name: 'Standard',
              description: 'For normal vision'
            },
            protanopia: {
              name: 'Protanopia',
              description: 'Red vision deficiency'
            },
            tritanopia: {
              name: 'Tritanopia',
              description: 'Blue vision deficiency'
            },
            deuteranopia: {
              name: 'Deuteranopia',
              description: 'Green vision deficiency'
            }
          }
        },
        verification: {
          title: 'Color vision verification',
          question: 'What is the color displayed below?'
        },
        running: {
          trial: 'Trial:',
          remaining: 'Remaining:',
          waitingMessage: 'Wait for the word to appear...'
        },
        feedback: {
          timeout: 'Time out!',
          correct: 'Correct!',
          incorrect: 'Incorrect! The correct color was'
        },
        results: {
          title: 'Stroop Test Results',
          congruentReactionTime: 'Reaction time (congruent)',
          incongruentReactionTime: 'Reaction time (incongruent)',
          stroopEffect: 'Stroop Effect',
          errorRate: 'Error rate',
          inhibitionRate: 'Inhibition rate',
          retryButton: 'Retry the test'
        },
        colors: {
          rouge: 'Red',
          vert: 'Green',
          bleu: 'Blue',
          jaune: 'Yellow',
          violet: 'Purple',
          orange: 'Orange',
          rose: 'Pink'
        }
      },
      trailMaking: {
        name: 'Trail Making Test',
        description: 'Cognitive flexibility and processing speed',
        instructions: {
          title: 'Instructions for the Trail Making Test',
          description1: 'This test measures your cognitive flexibility and processing speed.',
          partA: 'Part A: connect from 1 to 25 in order.',
          partB: 'Part B: alternately connect numbers (1→2…) and letters (A→B…): 1→A→2→B… up to 13.',
          drawing: 'Press the first point and, without lifting your finger, draw a continuous line through each point in order. The path will be displayed.',
          startButton: 'Start Test'
        },
        running: {
          partTitle: 'Trail Making Test – Part'
        },
        partB: {
          completedA: 'You have finished part A',
          description1: 'Part B will now start.',
          description2: 'This time, you will have to alternate between numbers and letters:',
          description3: '1 → A → 2 → B → ...',
          startButton: 'Start Part B'
        },
        results: {
          title: 'Trail Making Test Results',
          timeA: 'Part A time',
          timeB: 'Part B time',
          mistakesA: 'Part A errors',
          mistakesB: 'Part B errors',
          retryButton: 'Retry Test'
        }
      },
      nBack: {
        name: 'N-Back Test',
        description: 'Working memory evaluation',
        instructions: {
          title: 'Instructions for the N-Back test',
          description1: 'This test evaluates your working memory and concentration.',
          description2: 'Three levels will be offered: 1-back, 2-back, and 3-back. At each level, a series of numbers will be presented to you one by one.',
          description3: 'Your task is to indicate if the current number is identical to the one presented n positions back (n depends on the level: 1, 2, or 3).',
          description4: 'Press Identical if you think that\'s the case, otherwise press Different.',
          description5: 'The test includes {count} numbers per level. Try to respond as quickly and accurately as possible.',
          startLevel: 'Start level',
          level1: '1-back',
          level2: '2-back',
          level3: '3-back',
          startButton: 'Start Test'
        },
        running: {
          level: '{n}-Back Level',
          identical: 'IDENTICAL',
          different: 'DIFFERENT',
          memorize: 'Remember the order of the numbers appearing on the screen',
          next: 'Next'
        },
        results: {
          levelTitle: '{n}-Back level results',
          precision: 'Accuracy:',
          avgTime: 'Average time:',
          nextLevel: 'Go to {n}-Back',
          endTest: 'End test',
          finalTitle: 'N-Back Test Results',
          avgReactionTime: 'Average reaction time',
          validTrials: 'Valid trials',
          retryButton: 'Retry Test'
        }
      }
    },
    videoTests: {
      bess: {
        name: 'BESS Test',
        description: 'Balance evaluation',
        instructions: {
          title: 'Balance Test Instructions (BESS)',
          description1: 'This test measures your balance and postural stability.',
          description2: 'You will be asked to balance on one foot, with hands on your hips and eyes closed. The system will analyze your body movements using the front camera.',
          rules: {
            eyesClosed: 'Keep your eyes closed throughout the test.',
            handsOnHips: 'Keep your hands on your hips.',
            holdPosition: 'Stay still and hold the position for 20 seconds without losing balance.'
          },
          errors: 'An error is counted each time you open your eyes, move your feet, remove your hands from your hips, or lose your balance.',
          automatic: 'The test is automatic. It starts as soon as you are correctly positioned.',
          continueButton: 'Continue'
        },
        steps: {
          title: 'How to perform the test:',
          calibration: {
            title: '1. Calibration',
            description: 'Stand in front of the camera to calibrate the system'
          },
          position: {
            title: '2. Position to hold',
            description: 'Stand on one foot, hands on hips, eyes closed'
          },
          startButton: 'Start Test'
        },
        setup: {
          phoneStable: 'Place your phone on a stable surface',
          videoLoading: 'Video loading…'
        },
        calibration: {
          fullBody: 'Place your entire body in the frame',
          waiting: 'Calibration will start, do not move',
          inProgress: 'Calibration in progress, do not move',
          oneFoot: 'Stand on your non-dominant foot',
          handsOnHips: 'Put your hands on your hips',
          ready: 'The test will start, do not move'
        },
        testing: {
          message: 'Test in progress, close your eyes'
        },
        results: {
          title: 'Balance Test Results',
          oneFootErrors: 'Errors on 1 foot',
          retryButton: 'Retry Test'
        }
      },
      eyeTracking: {
        name: 'Eye Tracking',
        description: 'Eye movement tracking',
        instructions: {
          title: 'Eye Tracking Test Instructions',
          description1: 'This test measures your eye movements, visual attention, and ability to follow a stimulus.',
          description2: 'A white dot will move on the screen according to a specific path.',
          rule1: 'Keep your head still facing the screen.',
          rule2: 'Follow the dot only with your eyes, without moving your head.',
          rule3: 'Concentrate and try to stay attentive throughout the exercise.',
          description3: 'This test requires no interaction. It takes place automatically for a few seconds.',
          startButton: 'Start Test'
        },
        setup: {
          videoLoading: 'Video loading…',
          alignFace: 'Align your face with the contours'
        },
        results: {
          title: 'Eye Tracking Results',
          concussionProbability: 'Concussion probability',
          retryButton: 'Retry Test'
        }
      }
    },
    breatheExercise: {
      name: 'Breathing Exercises',
      description: 'Breathing and relaxation',
      instructions: {
        title: 'Choose a Breathing protocol',
        level: 'Level:',
        details: {
          recommendedContext: 'Recommended context:',
          contraindications: 'Contraindications:',
          remarks: 'Remarks:',
          breathingPhases: 'Breathing phases:',
          inhale: 'Inhale',
          holdInhale: 'Retention (full)',
          exhale: 'Exhale',
          holdExhale: 'Retention (empty)',
          seconds: 'seconds',
          recommendedCycles: 'Recommended cycles:',
          cyclesPerMinute: '{n} breaths per minute for {m} minutes',
          selectButton: 'Select this protocol',
          changeButton: 'Change exercise'
        }
      },
      running: {
        prepare: 'Get ready',
        relax: 'Relax, the exercise is about to start...',
        followRythm: 'Follow the rhythm indicated on the screen and the color changes to guide you.',
        cycle: 'Cycle:',
        timeRemaining: 'Remaining time:',
        inhale: 'Inhale',
        hold: 'Hold',
        exhale: 'Exhale',
        finishButton: 'Finish exercise'
      },
      results: {
        title: 'Breathing exercise finished',
        completionMessage: 'You have completed {completed} breathing cycles over a duration of {duration}.',
        mainEffect: 'Main effect:',
        recommendedContext: 'Recommended context:',
        feelings: 'How do you feel? Take a moment to observe the effects of this exercise on your body and mind.',
        backButton: 'Back to exercises'
      },
      protocols: {
        coherence: {
          name: 'Cardiac coherence',
          desc: 'Soothing',
          effect: 'General soothing, regulation of heart rate variability, stress reduction',
          context: 'relaxation, recovery, mental preparation, daily use',
          remarks: 'widely used in medical, sports, and meditation circles',
          level: 'Beginner',
          contraindications: 'none'
        },
        pranayama: {
          name: 'Gentle Pranayama',
          desc: 'Inspired by traditional yoga',
          effect: 'Emotional balancing, refocusing, slowing down of the mind',
          context: 'transitions, meditative practices, mental recovery',
          remarks: 'gentle transition to more complex practices',
          level: 'All levels',
          contraindications: 'avoid if feeling of oppression or dizziness'
        },
        respiration12: {
          name: '1:2 Breathing',
          desc: 'Prolonged calming',
          effect: 'Parasympathetic activation, cardiac and respiratory slowing',
          context: 'return to calm, post-effort recovery, acute stress',
          remarks: 'to be offered as "anti-panic breathing" in the app',
          level: 'Beginner',
          contraindications: 'none'
        },
        respiration21: {
          name: '2:1 Breathing',
          desc: 'Light activation',
          effect: 'Light cognitive and mental activation, increased alertness',
          context: 'pre-match, before speaking, mental warm-up',
          remarks: 'not to be confused with hyperventilation techniques',
          level: 'Beginner',
          contraindications: 'avoid in unmonitored hypertensive patients'
        },
        box: {
          name: 'Box Breathing',
          desc: 'Square breathing',
          effect: 'Mental recovery, refocusing, stress management',
          context: 'emotional management, stressful interviews, high-level sport',
          remarks: 'used by special forces and in mindfulness',
          level: 'Intermediate',
          contraindications: 'avoid in case of dizziness or acute respiratory disorders'
        },
        fourSevenEight: {
          name: '4-7-8',
          desc: 'Dr Andrew Weil',
          effect: 'Sleep induction, deep release',
          context: 'bedtime, high anxiety, deep relaxation',
          remarks: 'to be done sitting or lying down, never while driving',
          level: 'Advanced',
          contraindications: 'do not offer to people suffering from asthma, hyperventilation or severe hypotension'
        }
      }
    }
  },
  s: 's',
  ms: 'ms',
  forms: {
    title: 'My questionnaires',
    questionnaire: 'Questionnaire',
    available: 'Available',
    concussionHistory: {
      name: 'Concussion History',
      description: 'Your concussion background'
    },
    concussionSymptoms: {
      name: 'Symptom Self-Assessment',
      description: 'Daily questionnaire about your symptoms'
    },
    progressiveReturnFollowUp: {
      name: 'Progressive Return Follow-up',
      description: 'Assessment after each stage'
    }
  }
}
